// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__MLPolicyBilling__alertMsgContainer{display:inline}.app__MLPolicyBilling__alertMsgNoWrap{white-space:nowrap}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-gateway-react/Policies/MLPolicyBilling/MLPolicyBilling.module.scss"],"names":[],"mappings":"AAAA,yCACI,cAAA,CAGJ,sCACI,kBAAA","sourcesContent":[".alertMsgContainer {\n    display: inline;\n}\n\n.alertMsgNoWrap {\n    white-space: nowrap;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alertMsgContainer": "app__MLPolicyBilling__alertMsgContainer",
	"alertMsgNoWrap": "app__MLPolicyBilling__alertMsgNoWrap"
};
export default ___CSS_LOADER_EXPORT___;
